import styled from "styled-components";
import {
  Layout,
  Row,
  Col,
  Typography,
  Image,
  Button,
  Form,
  Space,
  Flex,
} from "antd";

export const LoginLayout = styled(Layout)`
  height: 100vh;

  background-color: white;
`;

export const LoginFormWrapper = styled(Space).attrs({
  direction: "vertical",
  size: "large",
})``;

export const StyledLoginForm = styled(Form).attrs({
  layout: "vertical",
  autoComplete: "off",
})``;

export const StyledLoginWarningText = styled(Typography.Text)`
  color: #ff0000;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
  direction: rtl;
  margin-top: 10px;
`;

export const StyledSentSuccessfully = styled(Typography.Text)`
  font-weight: 400;
  margin-top: 15px;
  display: block;
`;

export const StyledRow = styled(Row)`
  height: 100%;
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const StyledLeftCol = styled(Col)`
  background-size: cover;
  height: 100%;
  position: relative;
  background-color: #f6f8f9;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const StyledImage = styled.img`
  height: 100%;
  width: auto;
  max-width: 100%;
  object-fit: cover;
`;

export const StyledLogo = styled.img`
  position: absolute;
  bottom: 4rem;
  left: 4rem;
`;

export const StyledRightCol = styled(Col)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;
  background-color: #fff;
  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
  }
`;

export const StyledLoginTitle = styled(Typography.Title)`
  direction: rtl;
`;

export const StyledLoginImage = styled(Image)``;

export const StyledLoginButton = styled(Button)`
  width: 22.75rem;
  max-width: 100%;
  height: 3.75rem;
  border-radius: 100px;
  background: #d7fe01;
  color: #313131;
  font-size: 18px;
  margin-top: 20px;
`;

export const StyledFrgotPassword = styled.div`
  cursor: pointer;
  align-self: end;
  font-size: 12px;
  color: #808080;
`;

export const StyledLoginWrapper = styled(Flex).attrs({
  vertical: true,
})`
  direction: rtl;
  max-width: 100%;
`;

export const StyledForgotPasswordButton = styled(Button).attrs({
  type: "primary",
})`
  width: 100%;
  height: 44px;
  margin-top: 30px;
`;
